export class ValidationService {
    static getValidatorErrorMessage(validatorName: string, validatorValue?: any,errorMessage?: any) {
        let config = {
            'required': 'Required',
            'required_email': 'Please enter email address',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Invalid email address',
            'min_age': 'Age should be greater than 3 year',
            'required_age': 'Please enter age',
            'required_contact':'Contact number is required',
            'required_url':'Url is required',
            'required_validate':'Please enter correct format of url and it should start from http or https',
            'required_card':'Please enter card number',
            'required_cvv':'CVV is required',
            'invalid_card' : 'Please enter a valid card number',
            'cvv_length' : "Invalid CVV",
            'contact_length':'Contact number should be less then 15 digit',
            'numeric_required' : 'Please enter numeric value',
            'invalidPassword': 'Password should be at least 6 characters',
            'requiredPassword' :'Please enter password',
            'minlength': `Minimum length ${validatorValue.requiredLength}`,
            'maxlength' : 'Please enter a valid age'
        };

        return config[validatorName];
    }

    static creditCardValidator(control) {
             if(control.value=='') {
             return { 'required_card': true };
       }
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
            if(control.value){
            if(control.value&&control.value.match(/^\d([- ]*\d){12,16}$/)){
            return null;
        }else {

            return { 'invalid_card': true };
        }
            }
    }
    static cvvValidator(control) {
        if(control.value=='') {
             return { 'required_cvv': true };
       }
       if (control.value) {
        if (control.value&&control.value.match(/^[0-9]{3,4}$/)) {
            return null;
        }
        else {
             return { 'cvv_length': true };
           
        }
       }
    }
     static ageValidator(control) {
        if (control.value==undefined) {
            return { 'required_age': true };
        }
        if (control.value < 3) {
            return { 'min_age': true };
        }
         if (control.value > 100) {
            return { 'maxlength': true };
        } 
        else {
            return null;
        }
    }

    static emailValidator(control) {
        if(control.value==''){
             return { 'required_email': true };
        }
        //[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?
        // RFC 2822 compliant regex
        if (control.value && control.value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
            return null;
        } else {
            return { 'invalidEmailAddress': true };
        }
    }
    static contactValidator(control) {
        if(control.value==''){
             return { 'required_contact': true };
        }
       if(isNaN(control.value)){
           return { 'numeric_required': true };
       } 
       

    }

    static urlValidator(control) {
        // if(control.value==''){
        //      return { 'required_url': false };
        // }
        if(control.value!=''){
           // var regex = new RegExp("^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$");
           // var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|https:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
           var regex = new RegExp("^(http[s]?:\\/\\/(\\.)?|https:\\/\\/(\\.)?|ftp:\\/\\/(\\.)?|\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            var valid = regex.test(control.value);
            if(!valid) {
                return { 'required_validate': true };
            }
            if(control.value==''){
                return { 'required_validate': false };
            }
        }
        
        
    }

    static passwordValidator(control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
       //Password should be at least 6 characters
       if(control.value=='') {
             return { 'requiredPassword': true };
       }
       if(control.value && control.value.length < 6) {
            return { 'invalidPassword': true };
       } else {
           return null;
       }
        // if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
        //     return null;
        // } else {
        //     return { 'invalidPassword': true };
        // }
    }
    
     static requiredpassValidator(control) {
       if(control.value=='') {
             return { 'requiredPassword': true };
       } else {
           return null;
       }
    }
}




// WEBPACK FOOTER //
// ./src/app/services/validation.service.ts